import { BACKEND_ORIGIN } from '../../utils/config/constants';

type YandexLoginButtonProps = {
  className?: string;
};

const YandexLoginButton = ({ className }: YandexLoginButtonProps) => {
  const handleLogin = () => {
    window.location.href = `${BACKEND_ORIGIN}/oauth2/authorization/yandex`;
  };

  return (
    <button className={className} type="button" onClick={handleLogin}>
      Войти через Яндекс
    </button>
  );
};

export default YandexLoginButton;
